export const siteConfig = {
  name: "mogu",
  tagline: "探索无限可能",
  description: "mogu 是一个综合性智能平台，致力于为用户提供高效、便捷的数字工具和解决方案。无论你是初学者还是专业用户，mogu 都能帮助你提升工作效率，释放创造力。",
  url: "https://mogu.com",
  logo: "mogu",
  foundedYear: 2020,
  email: "contact@mogu.com",
  phone: "400-888-9999",
  address: "北京市海淀区中关村科技园区创新大厦 18 层",
  social: {
    weibo: "https://weibo.com/mogu",
    wechat: "mogu_official",
    zhihu: "https://zhihu.com/mogu",
  },
  keywords: "mogu,mogu官网,mogu平台,mogu使用教程,mogu下载,mogu功能介绍,mogu最新版本",
};

export const categoryList = [
  {
    id: "tutorial",
    name: "使用教程",
    slug: "tutorial",
    description: "从入门到精通，全面掌握 mogu 的各类操作技巧与最佳实践",
    icon: "ri-book-open-line",
    count: 24,
  },
  {
    id: "features",
    name: "功能介绍",
    slug: "features",
    description: "深入了解 mogu 平台的各项核心功能与创新特性",
    icon: "ri-stack-line",
    count: 18,
  },
  {
    id: "updates",
    name: "最新版本",
    slug: "updates",
    description: "追踪 mogu 最新版本动态，了解每次更新的亮点与改进",
    icon: "ri-rocket-line",
    count: 12,
  },
  {
    id: "download",
    name: "下载指南",
    slug: "download",
    description: "获取 mogu 各平台客户端，详细安装指引与配置说明",
    icon: "ri-download-cloud-line",
    count: 8,
  },
  {
    id: "news",
    name: "行业资讯",
    slug: "news",
    description: "了解 mogu 相关行业动态、技术趋势与发展方向",
    icon: "ri-newspaper-line",
    count: 15,
  },
];

export const featureHighlights = [
  {
    id: "feature-1",
    title: "智能分析引擎",
    description: "采用先进的 AI 算法，实时分析数据并提供深度洞察，帮助您做出更明智的决策。支持多维度数据交叉分析，自动生成可视化报告。",
    icon: "ri-brain-line",
  },
  {
    id: "feature-2",
    title: "高效协作平台",
    description: "打破团队沟通壁垒，实现文档共享、实时编辑与版本管理。支持多人同时在线协作，大幅提升团队生产力。",
    icon: "ri-team-line",
  },
  {
    id: "feature-3",
    title: "安全数据加密",
    description: "采用银行级加密技术，全方位保护您的数据安全。支持端到端加密传输，确保信息在传输和存储过程中的绝对安全。",
    icon: "ri-shield-check-line",
  },
  {
    id: "feature-4",
    title: "多端无缝同步",
    description: "无论是在桌面端、移动端还是网页端，mogu 都能实现数据的实时同步，让您随时随地继续工作，体验无缝切换的畅快感。",
    icon: "ri-device-line",
  },
  {
    id: "feature-5",
    title: "开放 API 接口",
    description: "提供丰富的 API 接口与 SDK，支持快速集成到现有工作流程中。完善的开发者文档让集成变得轻而易举。",
    icon: "ri-code-s-slash-line",
  },
  {
    id: "feature-6",
    title: "智能自动化流程",
    description: "通过可视化流程编辑器，轻松构建自动化工作流。减少重复性劳动，让团队专注于高价值创造工作。",
    icon: "ri-flow-chart",
  },
];